// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';   // React 18 için
import './index.css';                      // varsa global stiller
import App from './App';

// “root”u bulun
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

// Uygulamayı bağla
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
